// ADV-1202 / ADR-0053: W3C Trace Context envelope carried inside the media
// pipeline's queue message bodies so a consumer can start its root span as a
// child of the producer's span (Cloudflare does not link queue producer→consumer
// trace context). Optional everywhere — in-flight messages enqueued before this
// change parse fine and degrade to a parentless root span.

import { z } from "zod";

export const TraceCarrierSchema = z
  .object({
    traceparent: z.string().min(1).describe("Traceparent"),
    tracestate: z.string().optional().describe("Tracestate"),
  })
  .describe("Trace Carrier");

export type TraceCarrier = z.infer<typeof TraceCarrierSchema>;
